module.exports = __webpack_public_path__ + "static/media/MPV.cdc776b2.svg";